import React from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "../../../redux/actions/modals";
import Button from "../button";
import ModalTemplate from "./template";

const ProfilePictureModal = () => {
  const dispatch = useDispatch();
  const hide = () => {
    dispatch(hideModal());
  };

  return (
    <ModalTemplate title="راهنمای انتخاب تصویر پروفایل" icon="far fa-star">
      <div className="p-5 leading-6 text-normal">
        <ul className="list-disc">
          <li>عکس پروفایل از شخص متخصص و به صورت عمودی باشد.</li>
          <li>عکس ارسالی سلفی و یا پرسنلی نباشد.</li>
          <li>در عکس از لباس رسمی و مناسب استفاده کنید که نشان دهنده حرفه شما باشد.</li>
          <li>عکس در مطب یا در فضای مشابه مرتب و منظم گرفته شود تا تصویر مثبتی از شما به افراد منتقل کند.</li>
          <li>از داشتن عینک آفتابی و ماسک در عکس پرهیز کنید.</li>
          <li>از گذاشتن دست زیر چانه خودداری فرمایید.</li>
          <li>به دوربین نگاه کنید و لبخند بزنید. لبخند حس مثبتی به مراجعان منتقل می‌کند.</li>
          <li>عکس کراپ شده و عکس دسته جمعی نباشد.</li>
          <li>عکس به تازگی گرفته شده باشد. (بیش از یک سال از گرفته شدن آن سپری نشده باشد)</li>
          <li>
            از عکس باکیفیت بالا و حداقل حجم آن 2 مگابایت استفاده شود. نور عکس مناسب باشد. (عکس خیلی تاریک یا خیلی روشن
            نباشد)
          </li>
          <li>شئونات اسلامی رعایت شده باشد.</li>
        </ul>
      </div>
      <div>
        <Button className="w-full" onClick={hide}>
          بستن توضیحات
        </Button>
      </div>
    </ModalTemplate>
  );
};

export default ProfilePictureModal;
